import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { UserRole } from '@leedpulse-monorepo/enums';
import { Authentication } from '@leedpulse-monorepo/classes';

async function connectSepteo(
  payload: ConnectSepteoPayload,
  auth: Authentication
): Promise<void> {
  try {
    if (![UserRole.owner, UserRole.admin].includes(auth.role)) {
      throw new ConnectSepteoFailure('Unauthorized', 'unauthorized');
    }
    await HttpClient.post('/leedflow/user/connect-septeo', payload.toAPIPayload(), auth.token);
    return;
  } catch (e) {
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new ConnectSepteoFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new ConnectSepteoFailure(`Erreur lors de la connexion Septeo : ${e.message}`, '400');
    }
  }
}

export class ConnectSepteoPayload {
  constructor(
    private userId: string,
    private companyId: string,
    private subscriptionId: string,
    private partnerApiKey: string,
    private partnerUid: string,
    private partnerUidUser: string
  ) {}

  toAPIPayload(): Record<string, string> {
    return {
      user_id: this.userId,
      company_id: this.companyId,
      subscription_id: this.subscriptionId,
      partner_api_key: this.partnerApiKey,
      partner_uid: this.partnerUid,
      partner_uid_user: this.partnerUidUser,
    };
  }
}

export class ConnectSepteoFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default connectSepteo;
